// components/BrokerKPICards.jsx
import { Link } from "react-router-dom";

export default function BrokerKPICards({ counts, loading = false, projectPath = "/brokerprojects" }) {
  const items = [
    { key: "Requested", hint: "Open" },
    { key: "Scheduled", hint: "Upcoming" },
    { key: "Production", hint: "Active work" },
    { key: "Delivered", hint: "Completed" },
  ];

  const CARD =
    "rounded-2xl border border-white/15 bg-white/70 backdrop-blur-md " +
    "shadow-[0_10px_30px_rgba(0,0,0,0.08)] relative overflow-hidden " +
    "p-4 md:p-5 transition-transform duration-150 flex flex-col " + // make flex column
    "hover:scale-[1.015] hover:shadow-[0_16px_40px_rgba(0,0,0,0.10)] " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-strobe-red/60";

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {items.map(({ key, hint }) => {
        const value = counts?.[key] ?? 0;
        return (
          <Link
            key={key}
            to={`${projectPath}?status=${encodeURIComponent(key)}`}
            className={CARD}
            aria-label={`View ${key.toLowerCase()} projects`}
          >
            {/* subtle corner highlight */}
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(90%_60%_at_110%_-10%,rgba(255,255,255,0.35),transparent)]" />

            {/* Title */}
            <div className="text-[13px] md:text-sm font-medium text-black/60">
              {key}
            </div>

            {/* Value */}
            <div className="mt-1 text-3xl md:text-4xl font-extrabold tracking-tight text-[#1A1A1A]">
              {loading ? "—" : value}
            </div>

            {/* Push hint to bottom */}
            <div className="mt-auto text-[12px] text-black/45">{hint}</div>
          </Link>
        );
      })}
    </div>
  );
}
